import React, { useState, useEffect, useContext  } from 'react';
import ReactPaginate from 'react-paginate';
import '../Styles/CardEscenario.css'; // Asegúrate de que esta ruta sea correcta
import { AgregarCardBoton } from '../../AddCard/Components/AddComponent';
import { useNavigate } from 'react-router-dom';
import escenario1 from '../../../assets/escenarios.jpg'; // Agrega imágenes de escenarios
import { FrmEscenario } from './FrmEscenario';
import { ModalUtil } from '../../ModalUtil/Components/ModalUtilComponent';
import { BASE_URL } from './../../../config';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { AuthContext } from '../../../context/AuthContext';

const token = localStorage.getItem('token');

/**
 * Elimina un equipo por su ID.
 * @param {number|string} idScenary - El ID del equipo a eliminar.
 * @returns {Promise<Object>} - La respuesta del servidor.
 * @throws Will throw an error if the deletion fails.
 */
export const deleteScenaryById = async (idScenary) => {
    try {
        const response = await axios.delete(`${BASE_URL}escenarios/${idScenary}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data; // Retorna la respuesta si la eliminación es exitosa
    } catch (error) {
        console.error(`Error al eliminar el equipo con ID ${idScenary}:`, error); // Mensaje de error mejorado
        throw error; // Lanza el error para manejarlo en otro lugar
    }
};

const CardEscenarios = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [selectedEscenario, setSelectedEscenario] = useState(null);
    const [escenarios, setEscenarios] = useState([]);

    const itemsPerPage = 6;

    const { isAuthenticated, login, logout } = useContext(AuthContext);

    useEffect(() => {
        const fetchEscenarios = async () => {
            try {
                const response = await axios.get(`${BASE_URL}escenarios`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });
                setEscenarios(response.data);
            } catch (error) {
                console.error('Error al cargar los escenarios:', error);
            }
        };

        fetchEscenarios();
    }, []);

    const addEscenariosArray = (addedEquipo) => {
        setEscenarios(prevEquipos => [addedEquipo, ...prevEquipos]);
        toast.success('Equipo creado exitosamente');
        setSearchTerm('');
    };

    const updateEscenariosArray = (updatedEquipo) => {
        setEscenarios(prevEquipos =>
            prevEquipos.map(equipo =>
                equipo.id === updatedEquipo.id ? updatedEquipo : equipo
            )
        );
        toast.success('Equipo actualizado exitosamente');
        setSearchTerm('');
    };

    const filteredEscenarios = escenarios.filter(escenario =>
        escenario.nombreEscenario.toLowerCase().includes(searchTerm.toLowerCase()) ||
        escenario.sede.nombreSede.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handlePageClick = (data) => {
        setCurrentPage(data.selected);
    };

    const handleNavigateToDetalles = () => {
        navigate('/detalles-escenario'); // Cambia la ruta si es necesario
    };
    const handleOpenModal = (escenario = null) => {
        setSelectedEscenario(escenario);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedEscenario(null);
    };

    const handleDeleteEscenary = async (idScenary) => {
        try {
            await deleteScenaryById(idScenary);
            setEscenarios(prevEquipos => prevEquipos.filter(equipo => equipo.id !== idScenary));
            toast.success('Escenario eliminado con éxito');
        } catch (error) {
            toast.error('Error al eliminar el escenario:', error);
        }
    };

    const displayEscenarios = filteredEscenarios
        .slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage)
        .map(escenario => (
            <div key={escenario.id} className="escenario-card" >
                <img src={escenario.urlImagen} alt={escenario.nombreEscenario} className="escenario-image" />
                <h3 className="escenario-title">{escenario.nombreEscenario}</h3>
                {/* <p className="escenario-text">Ubicación: {escenario.ubicacion}</p> */}
                <div className="button-container">
                    <button className="action-button"
                        onClick={() => handleOpenModal(escenario)}>
                        <i className="fas fa-edit"></i> Actualizar
                    </button>
                    <button className="action-button"
                        onClick={() => handleDeleteEscenary(escenario.id)}>
                        <i className="fas fa-trash"></i> Eliminar
                    </button>
                    <button className="action-button" onClick={handleNavigateToDetalles}>
                        <i className="fas fa-info-circle"></i> Detalles
                    </button>
                </div>
            </div>
        ));

    return (
        <div className="escenario-container">
            <input
                type="text"
                placeholder="Buscar escenarios..."
                value={searchTerm}
                onChange={e => setSearchTerm(e.target.value)}
                className="search-input"
            />

            <div className="card-container">
                <div className="background-div">
                    <AgregarCardBoton image={escenario1} onOpenModal={handleOpenModal} />
                </div>
                {displayEscenarios}
            </div>

            {/* Modal para agregar o actualizar equipo */}
            {showModal && (
                <FrmEscenario
                    showModal={showModal}
                    handleCloseModal={handleCloseModal}
                    escenario={selectedEscenario ? selectedEscenario : null}
                    onAddEquipos={addEscenariosArray}
                    onUpdateEquipos={updateEscenariosArray}
                />
            )}
            <ReactPaginate
                pageCount={Math.ceil(filteredEscenarios.length / itemsPerPage)}
                onPageChange={handlePageClick}
                containerClassName="pagination"
                activeClassName="active"
                previousLabel={"< Anterior"}
                nextLabel={"Siguiente >"}
            />
        </div>
    );
};

export { CardEscenarios };
